import {Pipe, PipeTransform} from '@angular/core';
import {AdminI18nService} from './admin-i18n.service';

@Pipe({
  name: 'adminTranslate',
  standalone: true,
  pure: false
})
export class AdminTranslatePipe implements PipeTransform {
  constructor(private readonly i18n: AdminI18nService) {}

  transform(key: string | null | undefined, params?: Record<string, string | number | null | undefined>): string {
    if (!key) {
      return '';
    }
    return this.i18n.t(key, params);
  }
}
